<section class="content">
    <div class="container-fluid pl-0 pr-0">
        <div class="block-header">
            <div style="margin-top: 2%;border: 2px solid #446f8b;; margin-bottom: 1%;" [hidden]="!ShowSearch">
                <div style="margin: 2%;">
                    <div class="master-de">
                        <form [formGroup]="DrawingsAdherenceForm" autocomplete="off">
                            <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
                            <div class="row">
                                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                                    <EIPDateRangePicker [IsSelectionRequired]=true [valueStart]=ScheduleStartDate [valueEnd]=ScheduleEndDate setid="dtRangeDate" WaterMark="Schedule Start & End Date" (selectedStartDate)='getStartDateValue($event)' (selectedEndDate)='getEndDateValue($event)' [ShowClearIcon]="true">
                                    </EIPDateRangePicker>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                                    <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="displayText"  ValueField="dedShortDescription" WaterMarkText="Workflow Status" [dataSource]='stageList' (valueChange)='selectedStage($event)' [IsCascading]='true'>
                                    </EIPAutoComplete>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12"></div>
                                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                                    <button style="float: right;" class="btn btn-primary btn-sm" (click)="finalView()"><i class="fa fa-refresh" title="Load Report" aria-hidden="true"></i>&nbsp;&nbsp;Load Report</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row m-0 eip-pt-20">
                <kendo-grid [kendoGridBinding]="Datalist" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [filterable]="false" [pageable]="true" id="grvInternal" [rowClass]="rowCallback" [height]="540">
                    <ng-template kendoPagerTemplate>
                        <div class="k-pager-left">
                            <kendo-pager-info></kendo-pager-info>
                        </div>
                        <div class="k-pager-right">
                            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                            <kendo-pager-input></kendo-pager-input>
                            <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                        <ng-template kendoGridToolbarTemplate>
                            <div class="k-grid-toolbar-content d-flex justify-content-end">
                                <div class="flex-grow-1 title-container">
                                    <button style="float: left;background-color:#ecdd4e;margin-right: 5px;" class="btn btn-sm" (click)="advanced_Filter()"><i class="fa fa-clock-o" title="Advance Release" aria-hidden="true"></i>&nbsp;&nbsp;Advance Release</button>
                                    <button style="float: left;background-color:#99eb96;margin-right: 5px;" class="btn btn-sm" (click)="ontime_Filter()"><i class="fa fa-send" title="On Time Release" aria-hidden="true"></i>&nbsp;&nbsp;On Time Release</button>
                                    <button style="float: left;background-color:#eea068;" class="btn btn-sm" (click)="delayed_Filter()"><i class="fa fa-clock-alarm" title="Delayed Release" aria-hidden="true"></i>&nbsp;&nbsp;Delayed Release</button>
                                </div>
                                <div class="icons-container">
                                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">

                                        <div class="icon-wrap">
                                            <i class="fa fa-search" title="Search Filter" (click)="toggleShowSearch()" aria-hidden="true"></i>
                                            <span class="list-icon-name">Search Filter</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider-container d-none d-md-block" id="imgDivider">
                                    <span></span>
                                </div>
                                <div class="pagination-container">
                                    <p id="lblShowDetails">Show</p>
                                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                    </kendo-pager-page-sizes>
                                    <span>Items</span>
                                </div>
                                <div class="divider-container d-none d-md-block" id="imgDivider">
                                    <span></span>
                                </div>
                                <div class="icons-container">
                                    <div class="icon-wrap">
                                        <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to Excel</button>
                                    </div>
                                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                        <div class="icon-wrap">
                                            <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                            <span class="list-icon-name">Filter</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-template>
                    <kendo-grid-column title="Sl.No." [width]="40">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            {{rowIndex + 1}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Doc No" field="doc_No" [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.doc_No}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.doc_No}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Title" field="doc_Title" [width]="200">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.doc_Title}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.doc_Title}}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="doc_Title"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="WF Status" field="stages_desc" [width]="80">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.stages_desc}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.stages_desc}}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="stages_desc"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Revision" field="revision_No" [width]="60">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.revision_No}}" eipTooltipPosition="auto">{{dataItem.revision_No}}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="revision_No"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Print Size" field="size" [width]="60">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.size}}" eipTooltipPosition="auto">{{dataItem.size}}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="size"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Scheduled On" field="scheduled_On" [width]="110">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            <span class="no-wrap" eipTooltip="{{dataItem.scheduled_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.scheduled_On | date:'dd-MMM-yyyy'}}</span>
                        </ng-template>
                        <!-- Date Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-datepicker-filter [filter]="filter" field="scheduled_On"></app-datepicker-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Submitted On / Completed On" field="completed_On" [width]="110">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            <span class="no-wrap" eipTooltip="{{dataItem.completed_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{(dataItem.completed_On !== null) ?(dataItem.completed_On | date:'dd-MMM-yyyy'): "" }}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="completed_On"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Delay" field="delay_Days" [width]="60">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.delay_Days}}" eipTooltipPosition="auto">{{dataItem.delay_Days}}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="delay_Days"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Delay Reason" field="delay_Reason" [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.delay_Reason}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.delay_Reason}}</span>
                        </ng-template>
                        <!-- Dropdown Filter -->
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <app-dropdown-filter [filter]="filter" [data]="Datalist" Field="delay_Reason"></app-dropdown-filter>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-excel fileName="DrawingsAdherenceList.xlsx" [fetchData]="allData"></kendo-grid-excel>
                </kendo-grid>
            </div>
            <div class="row m-0 eip-pt-20">
                <kendo-grid [kendoGridBinding]="CalDatalist" [sortable]="true" [resizable]="true" [filterable]="cal_enableFilter" [reorderable]="true" [filterable]="false" [pageSize]="10" [pageable]="true" id="grvInternal">
                    <ng-template kendoPagerTemplate>
                        <div class="k-pager-left">
                            <kendo-pager-info></kendo-pager-info>
                        </div>
                        <div class="k-pager-right">
                            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                            <kendo-pager-input></kendo-pager-input>
                            <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                        <ng-template kendoGridToolbarTemplate>
                            <div class="k-grid-toolbar-content d-flex justify-content-end">
                                <div class="icons-container">
                                    <div class="icon-wrap">
                                        <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to Excel</button>
                                    </div>
                                    <div class="icon-wrap">
                                        <i class="fa fa-filter" title="Filter" (click)="caltoggleFilter()" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-template>
                    <kendo-grid-column title="Description" field="description" [width]="70">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.description}}" eipTooltipPosition="auto">{{dataItem.description}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Value" field="value" [width]="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.value}}" eipTooltipPosition="auto">{{dataItem.value}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Average Delay Days" field="avg_delayed_days" [width]="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.avg_delayed_days}}" eipTooltipPosition="auto">{{dataItem.avg_delayed_days}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Percentage(%)" field="percentage" [width]="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.percentage}}" eipTooltipPosition="auto">{{dataItem.percentage}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-excel fileName="DrawingsAdherenceCalList.xlsx" [fetchData]="fullData"></kendo-grid-excel>
                </kendo-grid>
            </div>
        </div>
    </div>
</section>